/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { VISUAL_HEADER_TYPES } from './constants';

const mapper = {
  Transactions_Agg: {
    groupBy: '',
    headerType: VISUAL_HEADER_TYPES.SINGLE,
    transformColumns: true,
    metrics: [
      'TransactionID',
      'HotelCode',
      'Arrival Date',
      'Departure Date',
      'Confirmation Date',
      'Status',
      'Channel',
      'Sub Channel',
      'Assigned Segment',
      'Market Segment',
      'Rate Category',
      'Sub Rate Category',
      'Region',
      'Country',
      'Total Nights',
      'Room Count for Date Range',
      'Revenue for Date Range',
      'ADR for Date Range',
    ],
  },
  Transactions_DeAgg: {
    groupBy: '',
    headerType: VISUAL_HEADER_TYPES.SINGLE,
    transformColumns: true,
    metrics: [
      'TransactionID',
      'HotelCode',
      'Arrival Date',
      'Departure Date',
      'Confirmation Date',
      'Stay Date',
      'Status',
      'Channel',
      'Sub Channel',
      'Assigned Segment',
      'Market Segment',
      'Rate Category',
      'Sub Rate Category',
      'Region',
      'Country',
      'Total Nights',
      'Room Count for Date Range',
      'Revenue for Date Range',
      'ADR for Date Range',
    ],
  },
};

export default mapper;
